import Wallet from "@/models/Accounts/DepositAccounts/Wallets/Wallet";

export default class UpdateWalletDetailsRequest {

    name: string = '';

    public constructor(currentWallet: Wallet) {
        this.name = currentWallet.name;
    }
}